import { useContext, useState } from "react"
import { LanguageContext, NotificationContext } from "../context"
import { submitContactForm } from "../services/messaging"

const ContactModal = ({ title, onClose, onSend, showModal }) => {

  const { t } = useContext(LanguageContext)
  const { toast } = useContext(NotificationContext)

  const [message, setMessage] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [sending, setSending] = useState(false)

  const handleSend = async () => {
    const processedMessage = message.trim()
    if(!processedMessage) {
      toast({ message: t('message.empty_error'), variant: 'error' })
      return
    }
    setSending(true)
    const response = await submitContactForm(name, email, message)
    setSending(false)
    if(response.error) {
      toast({ message: response.error.message, variant: 'error' })
      return 
    }
    setMessage('')
    onClose()
    toast({ message: t('message.sent_toast'), variant: 'success' })
  }

  const handleClose = () => {
    setMessage('')
    onClose()
  }

  return (
    <div className={`w-full ${showModal ? '' : 'hidden'}`}>
      <div
        className="justify-center items-center z-60 rounded-lg modal-container ">
        <div className="flex items-start justify-between pt-16 pb-9 px-5  ">
          <h3 className="modal-title">
            {t('contact.title')}
          </h3>
          <button
            className="p-1 bg-transparent text-black text-3xl absolute top-2 right-4"
            onClick={handleClose}
          >
            ×
          </button>
        </div>
        <div className="pt-4 px-5 pb-8">
          <p className='content-text !text-center mx-auto'>
            {t('contact.text1')} {t('contact.text2')} {t('contact.text3')}
          </p>
          <p className='content-text mx-auto !text-center'>
          {t('contact.text4')} <a href={`mailto:${t('contact.admin_email')}`} className='font-semibold'>{t('contact.admin_email')}</a> {t('contact.text_form')}
          </p>
        </div>
        <div className="modal-box mt-2">
          <div className="modal-body">
            <div className="flex flex-col gap-2 mb-6">
              <label className="text" htmlFor="name">
                {t('contact.name')}*
              </label>
              <input
                className="w-full border border-gray-300 rounded-md p-4"
                placeholder={t('contact.name')}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="flex flex-col gap-2 mb-6">
              <label className="text" htmlFor="email">
                {t('contact.email')}*
              </label>
              <input
                className="w-full border border-gray-300 rounded-md p-4"
                placeholder={t('contact.email')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="flex flex-col gap-2 mb-6">
              <label className="text" htmlFor="message">
                {t('contact.message')}*
              </label>
              <textarea
                className="w-full h-40 border border-gray-300 rounded-md p-4"
                placeholder={t('message.placeholder')}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <div className="flex gap-4 mt-6">
                <button
                  className={`flex primary mid btn-loading ${sending ? 'running' : ''}`}
                  onClick={handleSend}
                >
                  <div className="loading"></div>
                  {t('generic.send')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-50 modal-bg" onClick={handleClose}></div>
    </div>
  )
}

export default ContactModal
